export default [
    {
        "name": "loyaltywelcome",
        "tags": "Café-Bars-Restaurants, Καφέ-Μπαρ-Εστιατόρια, Beauty-Fashion, Ομορφιά-Μόδα, Wellness-Hotels, Ευεξία-Ξενοδοχεία, Notifications, Ειδοποιήσεις",
        "languages": {
            "en": {
                "image": "loyalty_thank_you_en.png",
                "title": "Loyalty Welcome",
                "style": ""
            },
            "el": {
                "image": "loyalty_thank_you_gr.png",
                "title": "Έναρξη Προγράμματος Πιστότητας",
                "style": ""
            }
        }
    },
    {
        "name": "loyaltyreward",
        "tags": "Café-Bars-Restaurants, Καφέ-Μπαρ-Εστιατόρια, Beauty-Fashion, Ομορφιά-Μόδα, Wellness-Hotels, Ευεξία-Ξενοδοχεία, Notifications, Ειδοποιήσεις",
        "languages": {
            "en": {
                "image": "giftloyaltytemplateEN.png",
                "title": "Loyalty Reward",
                "style": ""
            },
            "el": {
                "image": "giftloyaltytemplateGR.png",
                "title": "Ανταμοιβή Προγράμματος Πιστότητας",
                "style": "font-size:smaller;"
            }
        }
    },
    {
        "name": "reengage",
        "tags": "Notifications, Ειδοποιήσεις, Café-Bars-Restaurants, Καφέ-Μπαρ-Εστιατόρια, Re engage, Επανασυνδεθείτε",
        "languages": {
            "en": {
                "image": "reengage-layout.jpg",
                "title": "Re engage",
                "style": ""
            },
            "el": {
                "image": "re_engage_gr.png",
                "title": "Επανασυνδεθείτε",
                "style": ""
            }
        }
    },
    {
        "name": "welcome",
        "tags": "Notifications, Ειδοποιήσεις, Café-Bars-Restaurants, Καφέ-Μπαρ-Εστιατόρια, Welcome to the club, Καλώς ήλθατε στο club",
        "languages": {
            "en": {
                "image": "welcometotheclub.jpg",
                "title": "Welcome to the club",
                "style": ""
            },
            "el": {
                "image": "welcome_to_the_club_gr.png",
                "title": "Καλώς ήλθατε στο club",
                "style": ""
            }
        }
    },
    {
        "name": "birthday",
        "tags": "Celebrations-Holidays, Εορτασμοί-Διακοπές, E-commerce, Ηλεκτρονικό Εμπόριο, Birthday, Γενέθλια",
        "languages": {
            "en": {
                "image": "birthday.png",
                "title": "Birthday",
                "style": ""
            },
            "el": {
                "image": "birthday_gr.png",
                "title": "Γενέθλια",
                "style": ""
            }
        }
    },
    {
        "name": "salonspa",
        "tags": "Wellness-Hotels, Ευεξία-Ξενοδοχεία, Newsletters, Spa & Wellness, Σπα",
        "languages": {
            "en": {
                "image": "salonspa.jpg",
                "title": "Spa & Wellness",
                "style": ""
            },
            "el": {
                "image": "spa_&_wellness_gr.png",
                "title": "Σπα",
                "style": ""
            }
        }
    },
    {
        "name": "fitness",
        "tags": "Newsletters, Wellness-Hotels, Ευεξία-Ξενοδοχεία, Fitness Class",
        "languages": {
            "en": {
                "image": "fitnessclass.jpg",
                "title": "Fitness Class",
                "style": ""
            },
            "el": {
                "image": "fitness_class_gr.png",
                "title": "Fitness Class",
                "style": ""
            }
        }
    },
    {
        "name": "mathcamp",
        "tags": "Newsletters, Registration, Εγγραφή",
        "languages": {
            "en": {
                "image": "registration.jpg",
                "title": "Registration",
                "style": ""
            },
            "el": {
                "image": "registration_gr.png",
                "title": "Εγγραφή",
                "style": ""
            }
        }
    },
    {
        "name": "masterclass",
        "tags": "Newsletters, Early Bird, Προεγγραφή",
        "languages": {
            "en": {
                "image": "earlybird.jpg",
                "title": "Early Bird",
                "style": ""
            },
            "el": {
                "image": "early_bird_gr.png",
                "title": "Προεγγραφή",
                "style": ""
            }
        }
    },
    {
        "name": "cocoonhotel",
        "tags": "Wellness-Hotels, Ευεξία-Ξενοδοχεία, Hotel, Ξενοδοχεία",
        "languages": {
            "en": {
                "image": "hotels.jpg",
                "title": "Hotel",
                "style": ""
            },
            "el": {
                "image": "hotel_gr.png",
                "title": "Ξενοδοχεία",
                "style": ""
            }
        }
    },
    {
        "name": "motorcycleclub",
        "tags": "Newsletters, Notifications, Ειδοποιήσεις, New Deliveries, v",
        "languages": {
            "en": {
                "image": "salepicks.jpg",
                "title": "New Deliveries",
                "style": ""
            },
            "el": {
                "image": "new_deliveries_gr.png",
                "title": "Νέες Παραλαβές",
                "style": ""
            }
        }
    },
    {
        "name": "notification",
        "tags": "Notifications, Ειδοποιήσεις",
        "languages": {
            "en": {
                "image": "notificationmain.jpg",
                "title": "Notification",
                "style": ""
            },
            "el": {
                "image": "notificationmain.jpg",
                "title": "Notification",
                "style": ""
            }
        }
    },
    {
        "name": "mothersday",
        "tags": "Newsletters, Celebrations-Holidays, Εορτασμοί-Διακοπές, Mother's Day",
        "languages": {
            "en": {
                "image": "mothersdaytop.jpg",
                "title": "Mother's Day",
                "style": ""
            },
            "el": {
                "image": "mothers_day_gr.png",
                "title": "Mother's Day",
                "style": ""
            }
        }
    },
    {
        "name": "celebration",
        "tags": "Newsletters, Celebrations-Holidays, Εορτασμοί-Διακοπές",
        "languages": {
            "en": {
                "image": "celebration.jpg",
                "title": "Celebration",
                "style": ""
            },
            "el": {
                "image": "celebration_gr.png",
                "title": "Celebration",
                "style": ""
            }
        }
    },
    {
        "name": "travelagency",
        "tags": "Newsletters, Wellness-Hotels, Ευεξία-Ξενοδοχεία, Travel Agency",
        "languages": {
            "en": {
                "image": "weeklydeal.jpg",
                "title": "Travel Agency",
                "style": ""
            },
            "el": {
                "image": "travel_agency_gr.png",
                "title": "Travel Agency",
                "style": ""
            }
        }
    },
    {
        "name": "newsletter",
        "tags": "Newsletters",
        "languages": {
            "en": {
                "image": "newsletter.jpg",
                "title": "Newsletter",
                "style": ""
            },
            "el": {
                "image": "newsletter_gr.png",
                "title": "Newsletter",
                "style": ""
            }
        }
    },
    {
        "name": "newcitybar",
        "tags": "Café-Bars-Restaurants, Καφέ-Μπαρ-Εστιατόρια, Newsletters, New City Bar",
        "languages": {
            "en": {
                "image": "happyhour.jpg",
                "title": "New City Bar",
                "style": ""
            },
            "el": {
                "image": "new_city_bar_gr.png",
                "title": "New City Bar",
                "style": ""
            }
        }
    },
    {
        "name": "winetasting",
        "tags": "Café-Bars-Restaurants, Καφέ-Μπαρ-Εστιατόρια, Newsletters, Wine Tasting",
        "languages": {
            "en": {
                "image": "promotion.jpg",
                "title": "Wine Tasting",
                "style": ""
            },
            "el": {
                "image": "wine_tasting_gr.png",
                "title": "Wine Tasting",
                "style": ""
            }
        }
    },
    {
        "name": "newrestaurant",
        "tags": "E-commerce, Ηλεκτρονικό Εμπόριο, Café-Bars-Restaurants, Καφέ-Μπαρ-Εστιατόρια, New Restaurant",
        "languages": {
            "en": {
                "image": "holidayspecial.jpg",
                "title": "New Restaurant",
                "style": ""
            },
            "el": {
                "image": "newrestaurant_gr.png",
                "title": "New Restaurant",
                "style": ""
            }
        }
    },
    {
        "name": "gamegiftcard",
        "tags": "Newsletters, E-commerce, Ηλεκτρονικό Εμπόριο, Gift Card",
        "languages": {
            "en": {
                "image": "giftcardmaster.jpg",
                "title": "Gift Card",
                "style": ""
            },
            "el": {
                "image": "gift_card_gr.png",
                "title": "Gift Card",
                "style": ""
            }
        }
    },
    {
        "name": "playfestival",
        "tags": "Newsletters, E-commerce, Ηλεκτρονικό Εμπόριο, Festival",
        "languages": {
            "en": {
                "image": "festivalmaster.jpg",
                "title": "Festival",
                "style": ""
            },
            "el": {
                "image": "festival_gr.png",
                "title": "Festival",
                "style": ""
            }
        }
    },
    {
        "name": "thankyou",
        "tags": "Café-Bars-Restaurants, Καφέ-Μπαρ-Εστιατόρια, Notifications, Ειδοποιήσεις, Thank You",
        "languages": {
            "en": {
                "image": "thank_you_template.png",
                "title": "Thank You",
                "style": ""
            },
            "el": {
                "image": "thank_you_template_gr.png",
                "title": "Thank You",
                "style": ""
            }
        }
    },
    {
        "name": "restaurantcoupon",
        "tags": "Café-Bars-Restaurants, Καφέ-Μπαρ-Εστιατόρια, E-commerce, Ηλεκτρονικό Εμπόριο, Restaurant Coupon",
        "languages": {
            "en": {
                "image": "restaurant-coupon_template.png",
                "title": "Restaurant Coupon",
                "style": ""
            },
            "el": {
                "image": "restaurant-coupon_template_gr.png",
                "title": "Restaurant Coupon",
                "style": ""
            }
        }
    },
    {
        "name": "hotelmember",
        "tags": "Wellness-Hotels, Ευεξία-Ξενοδοχεία, Hotel Member",
        "languages": {
            "en": {
                "image": "hotel_member_template.png",
                "title": "Hotel Member",
                "style": ""
            },
            "el": {
                "image": "hotel_member_template_gr.png",
                "title": "Hotel Member",
                "style": ""
            }
        }
    },
    {
        "name": "hairvoucher",
        "tags": "Beauty-Fashion, Ομορφιά-Μόδα, Notifications, Ειδοποιήσεις, Hair Voucher",
        "languages": {
            "en": {
                "image": "hair_voucher_template.png",
                "title": "Hair Voucher",
                "style": ""
            },
            "el": {
                "image": "hair_voucher_template_gr.png",
                "title": "Hair Voucher",
                "style": ""
            }
        }
    },
    {
        "name": "birthday2",
        "tags": "Celebrations-Holidays, Εορτασμοί-Διακοπές, Birthday",
        "languages": {
            "en": {
                "image": "birthday_template.png",
                "title": "Birthday",
                "style": ""
            },
            "el": {
                "image": "birthday_template_gr.png",
                "title": "Birthday",
                "style": ""
            }
        }
    },
    {
        "name": "sales",
        "tags": "Beauty-Fashion, Ομορφιά-Μόδα, E-commerce, Ηλεκτρονικό Εμπόριο, Newsletters, Sales",
        "languages": {
            "en": {
                "image": "sales_template.png",
                "title": "Sales",
                "style": ""
            },
            "el": {
                "image": "sales_template_gr.png",
                "title": "Sales",
                "style": ""
            }
        }
    },
    {
        "name": "missyou",
        "tags": "Newsletters, Notifications, Ειδοποιήσεις, Miss You",
        "languages": {
            "en": {
                "image": "miss_you_template.png",
                "title": "Miss You",
                "style": ""
            },
            "el": {
                "image": "miss_you_template_gr.png",
                "title": "Miss You",
                "style": ""
            }
        }
    },
    {
        "name": "newcollection",
        "tags": "Newsletters, Beauty-Fashion, Ομορφιά-Μόδα, New Collection",
        "languages": {
            "en": {
                "image": "fashion_new_collection_newsletter.png",
                "title": "New Collection",
                "style": ""
            },
            "el": {
                "image": "fashion_new_collection_newsletter_gr.png",
                "title": "New Collection",
                "style": ""
            }
        }
    },
    {
        "name": "welcomefashionshop",
        "tags": "Beauty-Fashion, Ομορφιά-Μόδα, E-commerce, Ηλεκτρονικό Εμπόριο, Fashion Shop",
        "languages": {
            "en": {
                "image": "welcome_email_fashion_shop.png",
                "title": "Fashion Shop",
                "style": ""
            },
            "el": {
                "image": "welcome_email_fashion_shop_gr.png",
                "title": "Fashion Shop",
                "style": ""
            }
        }
    },
    {
        "name": "newmenu",
        "tags": "Café-Bars-Restaurants, Καφέ-Μπαρ-Εστιατόρια, Newsletters, New Menu",
        "languages": {
            "en": {
                "image": "new_menu.png",
                "title": "New Menu",
                "style": ""

            },
            "el": {
                "image": "new_menu_gr.png",
                "title": "New Menu",
                "style": ""
            }
        }
    },
    {
        "name": "newcatalogclothes",
        "tags": "Beauty-Fashion, Ομορφιά-Μόδα, Newsletters, E-commerce, Ηλεκτρονικό Εμπόριο, New Catalog",
        "languages": {
            "el": {
                "image": "new_cataloggr.png",
                "title": "New Catalog",
                "style": ""
            },
            "en": {
                "image": "new_catalog.png",
                "title": "New Catalog",
                "style": ""
            }
        }
    },
    {
        "name": "freetrial",
        "tags": "Newsletters, Free Trial",
        "languages": {
            "el": {
                "image": "free_trialgr.png",
                "title": "Free Trial",
                "style": ""
            },
            "en": {
                "image": "free_trial.png",
                "title": "Free Trial",
                "style": ""
            }
        }
    },
    {
        "name": "clothesstore",
        "tags": "Beauty-Fashion, Ομορφιά-Μόδα, Clothes Store",
        "languages": {
            "el": {
                "image": "clothes_store_gr.png",
                "title": "Clothes Store",
                "style": ""
            },
            "en": {
                "image": "clothes_store.png",
                "title": "Clothes Store",
                "style": ""
            }
        }
    },
    {
        "name": "perfume",
        "tags": "Beauty-Fashion, Ομορφιά-Μόδα, Perfume",
        "languages": {
            "el": {
                "image": "new_perfume_gr.png",
                "title": "Perfume",
                "style": ""
            },
            "en": {
                "image": "new_perfume.png",
                "title": "Perfume",
                "style": ""
            }
        }
    },
    {
        "name": "merrychristmas",
        "tags": "Celebrations-Holidays, Εορτασμοί-Διακοπές, Merry Christmas",
        "languages": {
            "el": {
                "image": "christmas_gr_template.png",
                "title": "Merry Christmas",
                "style": ""
            },
            "en": {
                "image": "christmas_template.png",
                "title": "Merry Christmas",
                "style": ""
            }
        }
    },
    {
        "name": "easter",
        "tags": "Celebrations-Holidays, Εορτασμοί-Διακοπές, Easter",
        "languages": {
            "el": {
                "image": "easter_gr.png",
                "title": "Easter",
                "style": ""
            },
            "en": {
                "image": "easter_en.png",
                "title": "Easter",
                "style": ""
            }
        }
    },
    {
        "name": "blackfriday",
        "tags": "Beauty-Fashion, Ομορφιά-Μόδα, Newsletters, Black Friday",
        "languages": {
            "el": {
                "image": "black_friday_gr.png",
                "title": "Black Friday",
                "style": ""
            },
            "en": {
                "image": "black_friday.png",
                "title": "Black Friday",
                "style": ""
            }
        }
    },
    {
        "name": "goodmorningcoffee",
        "tags": "Café-Bars-Restaurants, Καφέ-Μπαρ-Εστιατόρια, Good Morning Coffee",
        "languages": {
            "el": {
                "image": "coffee_morning_gr.png",
                "title": "Good Morning Coffee",
                "style": ""
            },
            "en": {
                "image": "coffee_morning.png",
                "title": "Good Morning Coffee",
                "style": ""
            }
        }
    },
    {
        "name": "hotelbooknow",
        "tags": "Wellness-Hotels, Ευεξία-Ξενοδοχεία, Notifications, Ειδοποιήσεις, E-commerce, Ηλεκτρονικό Εμπόριο, Book Now",
        "languages": {
            "el": {
                "image": "book_now_gr.png",
                "title": "Book Now",
                "style": ""
            },
            "en": {
                "image": "book_now.png",
                "title": "Book Now",
                "style": ""
            }
        }
    },
    {
        "name": "mobiletv",
        "tags": "Newsletters, E-commerce, Ηλεκτρονικό Εμπόριο, Mobile TV",
        "languages": {
            "el": {
                "image": "technology_gr.png",
                "title": "Mobile TV",
                "style": ""
            },
            "en": {
                "image": "technology.png",
                "title": "Mobile TV",
                "style": ""
            }
        }
    },
    {
        "name": "travel",
        "tags": "Wellness-Hotels, Ευεξία-Ξενοδοχεία, Travel",
        "languages": {
            "el": {
                "image": "travel_gr.png",
                "title": "Travel",
                "style": ""
            },
            "en": {
                "image": "travel.png",
                "title": "Travel",
                "style": ""
            }
        }
    },
    {
        "name": "pharmacy",
        "tags": "Wellness-Hotels, Ευεξία-Ξενοδοχεία, Beauty-Fashion, Ομορφιά-Μόδα, Pharmacy",
        "languages": {
            "el": {
                "image": "pharmacy_gr.png",
                "title": "Pharmacy",
                "style": ""
            },
            "en": {
                "image": "pharmacy.png",
                "title": "Pharmacy",
                "style": ""
            }
        }
    },
    {
        "name": "watersports",
        "tags": "Wellness-Hotels, Ευεξία-Ξενοδοχεία, Water Sports",
        "languages": {
            "el": {
                "image": "water_sports_gr_template.jpg",
                "title": "Water Sports",
                "style": ""
            },
            "en": {
                "image": "water_sports_template.jpg",
                "title": "Water Sports",
                "style": ""
            }
        }
    },
    {
        "name": "cinema",
        "tags": "Newsletters, E-commerce, Ηλεκτρονικό Εμπόριο, Cinema",
        "languages": {
            "el": {
                "image": "cinema_gr_template.jpg",
                "title": "Cinema",
                "style": ""
            },
            "en": {
                "image": "cinema_template.jpg",
                "title": "Cinema",
                "style": ""
            }
        }
    },
    {
        "name": "cosmetics",
        "tags": "Beauty-Fashion, Ομορφιά-Μόδα, Cosmetics",
        "languages": {
            "el": {
                "image": "cosmetics_gr_template.jpg",
                "title": "Cosmetics",
                "style": ""
            },
            "en": {
                "image": "cosmetics_template.jpg",
                "title": "Cosmetics",
                "style": ""
            }
        }
    },
    {
        "name": "gym",
        "tags": "Wellness-Hotels, Ευεξία-Ξενοδοχεία, Gym",
        "languages": {
            "el": {
                "image": "gym_gr_template.jpg",
                "title": "Gym",
                "style": ""
            },
            "en": {
                "image": "gym_template.jpg",
                "title": "Gym",
                "style": ""
            }
        }
    },
    {
        "name": "abandonmentshoppingcart",
        "tags": "Notifications, Ειδοποιήσεις, Shopping Cart",
        "languages": {
            "el": {
                "image": "coverjfy_gr.jpg",
                "title": "Shopping Cart",
                "style": ""
            },
            "en": {
                "image": "coverjfy.png",
                "title": "Shopping Cart",
                "style": ""
            }
        }
    },
    {
        "name": "medcenter",
        "tags": "Ευεξία-Ξενοδοχεία, Ιατρικό Κέντρο",
        "languages": {
            "el": {
                "image": "med_center_cover_1.png",
                "title": "Ιατρικό Κέντρο",
                "style": ""
            }
        }
    },
    {
        "name": "valentinesshopping",
        "tags": "Newsletters, Beauty-Fashion, Ομορφιά-Μόδα, Valentine's Shopping",
        "languages": {
            "el": {
                "image": "cover_valentines_shopping_gr_1.png",
                "title": "Valentine's Shopping",
                "style": ""
            },
            "en": {
                "image": "cover_valentines_shopping_1.png",
                "title": "Valentine's Shopping",
                "style": ""
            }
        }
    }
];
